import React, { Component } from "react";
import { ModalBody, ModalHeader, ModalFooter, Button, Input } from "reactstrap";
import { connect } from "react-redux";
import * as actions from "../../stores/actions/index";
import {
  fieldHasError,
  validateOnChange,
  onSubmit,
} from "../../helpers/formValidators";
import { translate } from "react-i18next";
import { showToast } from "../../helpers/toast";
class AddEditGateway extends Component {
  state = {
    mode: "Add",
    editGatewayId: false,
    isGatewayEditable: false,
    formGateway: {
      gatewayName: "",
      gatewayId: "",
    },
    id: "",
    formError: "",
  };

  addGatewayFn = (payload) => {
    const { addGateway } = this.props;
    addGateway(payload);
  };

  editGatewayFn = (payload, id) => {
    const { editGateway } = this.props;
    editGateway({ payload, id });
  };

  componentDidMount() {
    const { modalData } = this.props;
    if (modalData && modalData.gateway) {
      const { gateway } = modalData;
      this.setState({
        mode: "Edit",
        formGateway: {
          gatewayName: gateway.name,
          gatewayId: gateway.gatewayId,
        },
        id: gateway.id,
      });
    }
  }

  validateOnChange = (event) => {
    const state = validateOnChange(event, this.state);
    const updatedState = !event.target.value
      ? { ...state, formError: "" }
      : state;
    this.setState(updatedState);
  };

  onSubmit = (e) => {
    const state = onSubmit(e, this.state);

    this.setState(state);
    if (!this.state.formError) {
      if (!state.hasError) {
        const params = {
          gatewayName: this.state.formGateway.gatewayName,
          gatewayId: this.state.formGateway.gatewayId.toLowerCase(),
        };
        if (state.mode === "Add") {
          this.addGatewayFn(params);
        } else {
          this.editGatewayFn(params, state.id);
        }
      }
    }
    e.preventDefault();
  };

  /* Simplify error check */
  hasError = (formName, inputName, method) => {
    return fieldHasError(this.state, formName, inputName, method);
  };

  render() {
    const { toggleModal, t } = this.props;
    const { mode } = this.state;
    return (
      <React.Fragment>
        <form className="mb-3" name="formGateway" onSubmit={this.onSubmit}>
          <ModalHeader tag="strong" toggle={toggleModal}>
            <span style={{ textTransform: "capitalize" }}>
              {mode === "Add" ? t("dashboard.add") : t("dashboard.edit")}
            </span>{" "}
            {t("dashboard.gateways")}
          </ModalHeader>
          <ModalBody>
            <div className="form-group">
              <label className="text-muted">{t("dashboard.gatewayName")}</label>
              <div className="input-group with-focus">
                <Input
                  type="text"
                  name="gatewayName"
                  placeholder={t("dashboard.enterGatewayName")}
                  invalid={this.hasError(
                    "formGateway",
                    "gatewayName",
                    "required"
                  )}
                  onChange={this.validateOnChange}
                  data-validate='["required"]'
                  value={
                    !!this.state.formGateway.gatewayName.trim()
                      ? this.state.formGateway.gatewayName
                      : ""
                  }
                  minLength="3"
                />

                {this.hasError("formGateway", "gatewayName", "required") && (
                  <span className="invalid-feedback">
                    {t("dashboard.gatewayNameIsRequired")}
                  </span>
                )}
              </div>
            </div>
            <div className="form-group">
              <label className="text-muted">{t("dashboard.gatewayID")}</label>
              <div className="input-group with-focus">
                <Input
                  type="text"
                  name="gatewayId"
                  placeholder={t("dashboard.enterGatewayID")}
                  invalid={this.hasError(
                    "formGateway",
                    "gatewayId",
                    "required"
                  )}
                  onChange={this.validateOnChange}
                  data-validate='["required"]'
                  value={
                    !!this.state.formGateway.gatewayId.trim()
                      ? this.state.formGateway.gatewayId
                      : ""
                  }
                  minLength="2"
                  disabled={
                    this.state.mode === "Edit" && !this.state.editGatewayId
                  }
                />
                {this.state.mode === "Edit" && !this.state.editGatewayId && (
                  <span
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "8px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      this.setState({
                        isGatewayEditable: true,
                      })
                    }
                  >
                    <i className=" fas fa-pencil-alt mt-0"></i>
                  </span>
                )}
                {this.hasError("formGateway", "gatewayId", "required") && (
                  <span className="invalid-feedback">
                    {t("dashboard.gatewayIdIsRequired")}
                  </span>
                )}
              </div>
            </div>
            {this.state.isGatewayEditable && !this.state.editGatewayId && (
              <div className="form-group">
                <label className="text-muted">
                  {t("dashboard.enterPasswordToUnlockGatewayID")}
                </label>
                <div className="input-group with-focus">
                  <Input
                    type="text"
                    name="gatewayIDPassword"
                    placeholder={t("dashboard.enterPassword")}
                    onChange={(event) => {
                      const value = event.target.value;
                      this.setState({
                        password: value,
                      });
                    }}
                    data-param={30}
                  />
                  <Button
                    color="info"
                    style={{
                      borderTopLeftRadius: "0px !important",
                      borderBottomLeftRadius: "0px !important",
                    }}
                    onClick={() => {
                      if (this.state.password === "198104") {
                        this.setState({
                          editGatewayId: true,
                        });
                        showToast(
                          this.props.t(
                            "dashboard.youAreNowAuthorisedToChangeGatewayID"
                          ),
                          "success"
                        );
                      } else {
                        showToast(
                          this.props.t("dashboard.passwordDidntMatched"),
                          "error"
                        );
                      }
                    }}
                  >
                    {t("dashboard.verify")}
                  </Button>
                </div>
              </div>
            )}
            {/* {!!this.state.formError && <div style={{color: '#f05050', marginTop: '0.25rem', fontSize: '80%', width: '100%'}}>{`${this.state.formError === "gatewayName" ? "Gateway Name" : "Gateway ID"} is Required`}</div>} */}
          </ModalBody>
          <ModalFooter>
            <Button color="info" type="submit">
              {mode === "Add" ? t("dashboard.add") : t("dashboard.save")}
            </Button>
            <Button color="secondary" type="button" onClick={toggleModal}>
              {t("dashboard.cancel")}
            </Button>
          </ModalFooter>
        </form>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addGateway: (data) => dispatch(actions.addGateway(data)),
    editGateway: (data) => dispatch(actions.editGateway(data)),
  };
};

export default connect(
  null,
  mapDispatchToProps
)(translate("translations")(AddEditGateway));
